import NOTESFORM from "../components/notes";
import RateBox from "../components/rateBox";
import SideBar from "../components/sideBar";
import translateText, { currentLanguage } from "../signals/language.signal";

const NoteRate = () => {
  return (
    <div
      id="noteRate"
      className="align-items-sm-center d-flex  justify-content-center flex-column w-100"
    >
      <SideBar
        more={true}
        showAccount={true}
        title={translateText(currentLanguage.value, "NoteRateTitle")}
      />

      <NOTESFORM />
      <RateBox />
    </div>
  );
};

export default NoteRate;
